import { HeaderItems } from '~/utils/getHeaderItems'

import Icon from '~/components/Icon/IconView'

// import { gt } from '~/lib/gt'
import styles from './UserMenuComponents.module.css'
// import { getUserMenuRoutes } from './UserMenuList.constant'

export function MenuItem({ label, icon }: Readonly<{ label: string; icon: string }>) {
  return (
    <>
      <div className={styles.menuButtonIconContainer}>
        <Icon icon={icon} className={styles.menuButtonIcon} width={24} height={24} imgWidth={24} imgHeight={24} alt={`Icon ${icon}`} />
      </div>
      <h6 className={styles.menuButtonLabel}>{label}</h6>
    </>
  )
}

export function UserMenuList({ userMenuRoutes }: { userMenuRoutes: HeaderItems['userMenuRoutes'] }) {
  return (
    <div className={styles.buttonsContainer}>
      {userMenuRoutes.map(routeObj => (
        <a key={routeObj.href} href={routeObj.href} className={styles.menuButtonContainer}>
          {/* <MenuItem label={gt.tp('UserMenuItem', routeObj.label)} icon={routeObj.icon} /> */}
          <MenuItem label={routeObj.label} icon={routeObj.icon} />
        </a>
      ))}
    </div>
  )
}
